var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visibility-settings",attrs:{"title":_vm.settingsText}},[(_vm.isHidden)?_c('SvgIcon',{attrs:{"icon":"crossed-eye","size":"24","color":"ui-gray"}}):_c('SvgIcon',{attrs:{"icon":"eye","size":"24","color":"ui-gray"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }